<template>
  <header class="site_header">
    <div class="site_header__inner">
      <router-link
        tag="a"
        to="/mypage"
        class="site_header__logo_link"
        @click.native="reloadOrRedirectToMyPage()"
      >
        <SiteLogo />
        <span class="site_header__sr_only">マイページ</span>
      </router-link>
      <UserMenu
        v-if="loaded"
        :username="username"
        :coin="coin"
        :icon-url="iconUrl"
        :is-transfer-ng-region="isTransferNgRegion"
        :can-use-live2d="canUseLive2d"
      />
    </div>
  </header>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import SiteLogo from '@/components/Navigation/SiteLogo.vue'
import UserMenu from '@/components/Navigation/UserMenu.vue'

// v2 の site-header と同一レイアウトのサイトヘッダーを表示
@Component({
  components: {
    SiteLogo,
    UserMenu,
  },
})
export default class SiteHeader extends Vue {
  @Prop({ default: '' })
  username!: string

  @Prop({ default: 0 })
  coin!: number

  @Prop({ default: '' })
  iconUrl!: string

  @Prop({ default: true })
  loaded!: boolean

  @Prop({ default: false })
  isTransferNgRegion!: boolean

  @Prop({ default: false })
  canUseLive2d!: boolean

  reloadOrRedirectToMyPage(): void {
    // 現在のページがマイページな場合、リロードさせる
    if (this.$route.path === '/mypage') {
      location.reload()
    } else {
      this.$router.push('/mypage').catch(() => {})
    }
  }
}
</script>

<style scoped>
.site_header {
  position: fixed;
  top: var(--safe-area-inset-top, 0px);
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  z-index: 3;
}

.site_header::before {
  content: '';
  position: absolute;
  top: calc(-1 * var(--safe-area-inset-top, 0px));
  left: 0;
  right: 0;
  height: var(--safe-area-inset-top, 0px);
  background-color: #ffffff;
}

.site_header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 16px;
}

.site_header__logo_link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.site_header__sr_only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
